<template>
<div class="first-allocation">
  <el-form ref="form" :inline="false" :model="form">
    <el-row>
      <el-col :span="24">
        <div>
          <el-card shadow="never">
            <div slot="header" class="clearfix">
              二级指标/模块
            </div>
            <div style="max-height: 50vh;overflow: auto;">
              <el-tree :data="locationList" show-checkbox default-expand-all node-key="resourceId" ref="tree" :default-checked-keys="defaultChecked" highlight-current :props="defaultProps"></el-tree>
            </div>
          </el-card>
        </div>
      </el-col>
    </el-row>
    <el-form-item style="text-align: center;margin-top:30px">
      <el-button class="btn" type="primary" @click="addConfigResourceTree">保存</el-button>
    </el-form-item>
  </el-form>
</div>
</template>

<script>
import RESOURCEAPI from '@/api/resource';
export default {
  props: {
    projectName: {
      type: [String, Number]
    },
    projectId: {
      type: [String, Number]
    }
  },
  data() {
    return {
      form: {},
      defaultProps: {
        children: 'children',
        label: 'resourceNameShow'
      },
      locationList: [],
      defaultChecked: []
    };
  },
  created() {
    this.searchProjectResourceTreeV2();
  },
  methods: {
    //项目列表
    searchProjectResourceTreeV2() {
      let params = {
        projectId: this.projectId
      };
      RESOURCEAPI.searchProjectResourceTreeV2(params).then(res => {
        if (res.data.code == 200) {
          this.locationList = res.data.data;
          let result = this.COMM.getAllNode(this.locationList);
          this.defaultChecked = [];
          result.forEach(item => {
            if (item.checked == 1) {
              this.defaultChecked.push(item.resourceId);
            }
          });
        }
      });
    },
    //添加资源配置(组织资源配置、项目资源配置)
    addConfigResourceTree() {
      let checkedNode = this.$refs.tree.getCheckedNodes();
      let params = {
        configType: 2,
        dataConfigId: this.projectId,
        resourceIds: []
      };
      checkedNode.forEach(item => {
        params.resourceIds.push(item.resourceId);
      });
      RESOURCEAPI.addConfigResourceTree(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功');
          this.searchProjectResourceTreeV2();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.first-allocation {
  .btn {
    width: 120px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/boss/project/projectsecondmoduleconfig.vue